import _ from 'lodash'

import { defaultOptions } from '../../utils'
import { AvatarPieceBase } from '../Base'
import { Style as AvatarBeardNone } from './None'
import { Style as AvatarBeardStyle1 } from './Style1'
import { Style as AvatarBeardStyle2 } from './Style2'

export const NAME = 'beard'
export const STYLES = {
  none: AvatarBeardNone,
  style1: AvatarBeardStyle1,
  style2: AvatarBeardStyle2
}
export const INLINE_STYLE = {
  width: '220%',
  height: 'auto',
  left: '50%',
  top: 0,
  position: 'absolute',
  pointerEvents: 'none',
  transform: 'translateX(-50%) translateY(-5%)'
}
export const AvatarBeard = ({ style, color: colorSlug, ...rest }) => {
  const colorsOptions = _.get(defaultOptions, `${NAME}.colors`, [])
  const color = _.find(colorsOptions, { slug: colorSlug }) || colorsOptions[0]
  const colors = color.colors

  return (
    <AvatarPieceBase
      name={NAME}
      STYLES={STYLES}
      style={style}
      colors={colors}
      inlineStyle={INLINE_STYLE}
      {...rest}
    />
  )
}
